import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import IconButton from '../../../components/ui/IconButton';
import Tooltip from '../../../components/ui/Tooltip';
import { LinkButton, LineKey } from '../styles';
import { SERIES, SERIES_ORDER } from '../constants';
import { formatDayTitle } from '../format';
import { buildDrillLink } from '../../../utils/attendanceFilterQuery';

const Strip = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #F7F9FB;
  border: 1px solid #EEF1F5;
  font-size: 12px;
`;

const StripTitle = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Close = styled.span`
  margin-left: auto;
`;

const SERIES_LABEL = {
  late: 'attendanceDashboard.series.late',
  early: 'attendanceDashboard.series.early',
  absent: 'attendanceDashboard.series.absent',
};

// Grafikte bir güne tıklanınca: o günün listeleri (bugün devamsız değeri henüz yoksa o bağlantı çıkmaz) (tek tıklamada hangisinin isteneceği belirsiz — taslaktaki
// "o günün listesi"). Her bağlantı ilgili raporu panelin süzgeçleri + o günle açar.
export default function DayDrillStrip({ day, query, onClose }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  if (!day) return null;

  return (
    <Strip data-export-exclude data-drill-strip={day.date}>
      <StripTitle>{t('attendanceDashboard.trend.dayLists', { date: formatDayTitle(day.date, i18n.language) })}</StripTitle>
      {SERIES_ORDER.filter((kind) => day[kind] !== null && day[kind] !== undefined).map((kind) => (
        <Item key={kind}>
          <LineKey $color={SERIES[kind]} />
          <LinkButton
            type="button"
            data-drill={kind}
            onClick={() => history.push(buildDrillLink(kind, query, { from: day.date, to: day.date }))}
          >
            {`${t(SERIES_LABEL[kind])} ${day[kind] ?? 0} →`}
          </LinkButton>
        </Item>
      ))}
      <Close>
        <Tooltip text={t('attendanceDashboard.trend.close')}>
          <IconButton type="button" size="sm" onClick={onClose} aria-label={t('attendanceDashboard.trend.close')}>
            <X size={14} />
          </IconButton>
        </Tooltip>
      </Close>
    </Strip>
  );
}
